import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

const AlgoverseInsufficientBalanceAlert = () => {
  if (!ApplicationDomainUtility.isAlgoverse) return null;
  return (
    <div className="alert alert-sm alert-danger mt-3 py-1 px-2 text-wrap text-center">
      Your current wallet balance is negative. Please{' '}
      <a href="https://pro.upstox.com/funds/securities/wallet" target="_blank" rel="noopener noreferrer">
        add funds
      </a>{' '}
      to deploy/restart this strategy.
    </div>
  );
};

export default AlgoverseInsufficientBalanceAlert;
